/** "Sep 17, 3:04 PM" in the viewer's locale; empty for an unparseable date. */
export function formatActivityTimestamp(at: string): string {
  const d = new Date(at);
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
}
